export default __webpack_public_path__ + "static/media/14204-403255-15536.40001ffc.jpg";